const jobs = {
  bulk: {
    table: {
      direction: {
        to: 'Verteilen',
        from: 'Sammeln',
        both: 'Sammeln / Verteilen',
      },
    },

    direction: {
      label: 'Richtung',
      to: 'Zur Arbeit',
      from: 'Von der Arbeit',
      both: 'Zur Arbeit & Von der Arbeit',
    },

    form: {
      information: {
        passengers: {
          header: 'Mitarbeiter auswählen',
          fields: {
            passengers: 'Mitarbeiter',
          },
        },

        details: {
          fields: {
            direction: 'Richtung auswählen',
            shift: 'Arbeitszeit',
            from: 'Privat',
            to: 'Arbeit',
            fromHour: 'Schicht beginnt um',
            toHour: 'Schicht endet um',
          },
        },
        locations: {
          header: 'Arbeitsplatz',
          fields: {
            locations: 'Arbeitsplatz auswählen'
          }
        },
      },
    },
  },
};

export default jobs;
